module.exports = __webpack_public_path__ + "static/media/icon_cameras.1357e194.png";